<template>
  <div style="background-color:#0b0b0b">
    <div class="gameStart">
      <img src="https://file.o-lens.com/event/202412/gamestart.png" class="" alt="플레이어 넘버 발급">
      <div class="gameStart__numberList">
        {{ this.computedPlayerNumber }}
      </div>
      <v-btn class="gameStart__btn"
             @click="gameStart"
      >
        <img src="https://file.o-lens.com/event/202412/btn_start.png" class="" alt="게임 시작하기">
      </v-btn>
<!--      <v-btn v-if="custId && playerNumber !== undefined"-->
<!--             :cusId="custId"-->
<!--             class="gameStart__delete"-->
<!--             @click="gameDelete"-->
<!--      >-->
<!--        로그인 했을 경우만 노출 <br>-->
<!--        게임참여 삭제 버튼(test용)-->
<!--      </v-btn>-->
    </div>
    <img src="https://file.o-lens.com/event/202412/round1.png" class="" alt="ROUND1 줄다리기" id="round1" />
    <div class="gameProduct">
      <img src="https://file.o-lens.com/event/202412/vote_a.png" alt=""
           @click="productLink('20727')"
      >
      <img src="https://file.o-lens.com/event/202412/vote_b.png" alt=""
           @click="productLink('20712')"
      >
    </div>
    <video width="100%" height="100%" src="https://file.o-lens.com/event/202412/241224_movie3.mp4" type="video/mp4" loop="loop" muted="muted" playsinline="" autoplay="autoplay" class="event-video" style="background: #000000;" />
    <div class="gameVote">
      <div v-if="!this.computedVoteResult">
        <div class="btnVoteWrap">
          <button class="btnVoteWrap__team__a"
                  @click="selectVoteTeam('A')"
          >
            투표하기
          </button>
          <button class="btnVoteWrap__team__b"
                  @click="selectVoteTeam('B')"
          >
            투표하기
          </button>
        </div>
        <div class="voteText">
          지금 바로 승리하길 원하는 조를 선택하세요. <br>
          이벤트 기간 종료 후 <br>
          <span>승리한 조원들만 당첨의 기회</span>가 제공됩니다.
        </div>
      </div>
      <div v-if="this.computedVoteResult">
        <div class="voteResultWrap">
          <div class="voteResultWrap__bar">
            <div class="team__a"
                 :style="{width:voteResult.A + '%'}"
            >
              {{voteResult.A}}%
            </div>
            <div class="team__b"
                 :style="{width:voteResult.B + '%'}"
            >
              {{voteResult.B}}%
            </div>
          </div>
          <div class="voteText">
            본인이 선택한 조가 승리하길 바란다면 <br>
            <span>다른 친구와 함께 참여</span>해 <br>
            본인이 선택한 조의 득표수를 늘려보세요!
          </div>
        </div>
        <button class="btn_snsShare"
                @click="snsShare"
        >
          카카오톡으로 공유하기
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import numberFormat from "@/assets/filters/numberFormat";
import {webShareMixin} from "@/mixins/webShareMixin";
import {eventGetAttrsMixin} from "@/mixins/eventGetAttrsMixin";
import { get } from 'vuex-pathify';
export default {
  name: 'GameStart',
  mixins: [webShareMixin, eventGetAttrsMixin],
  filters: {
    numberFormat,
  },
  props: {
    postTitle: { type: [String, Number], default: null },
  },
  data: () => ({
    loading: true,
    playerNumber: "00000",
    voteResult: null,
    isClicking: false,
  }),
  computed: {
    custId: get('app/custId'),
    computedPlayerNumber() {
      return this.playerNumber !== undefined
          ? String(this.playerNumber).padStart(5, '0')
          : '00000';
    },
    computedVoteResult() {
      return this.voteResult
    },
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    snsShare() {
      // 조건 추가 (예: postTitle 유효성 검사)
      if (!this.postTitle || this.postTitle.trim() === '') {
        // 공유할 제목이 없을 때 처리
        console.error("Invalid postTitle: Cannot share without title.");
        return;
      }

      // 조건 통과 시 webShare 호출
      this.webShare(this.postTitle, this.postTitle, this.$route.fullPath);
    },
    checkLogin() {
      if (this.custId) {
        this.fetchGameInfo();
      }
    },
    fetchGameInfo() {
      this.$axios.get(`/v2/events/olens-game/votes`)
          .then(response => {
            if (response.data.code === 'SUCCESS') {
              this.playerNumber = response.data.data.playerNo;
              this.voteResult = response.data.data.voteResult
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    async fetchEventData() {
      await this.checkAccessDateTime();
      this.loading = true;
      Promise.all([
        this.getEventCount(),
        this.getEventCheck()
      ]).catch(error => {
        console.error("이벤트 데이터 로드 중 오류 발생:", error);
        // 오류 처리
      }).finally(() => {
        this.loading = false;
      });
    },
    gameStart() {
      if (this.isClicking) {
        this.$dialog.message.error('연속 참여는 불가능합니다. 잠시 후 시도해주세요.', { timeout: 1000 });
        return;
      }
      this.isClicking = true;
      this.isLoading = true; // response가 오기 전까지 loading 상태로 설정
      this.$axios.post(`/v2/events/olens-game/players`)
          .then(response => {
            if (response.data.code === 'CREATED') {
              this.playerNumber = response.data.data;
              this.voteScroll("round1");
              this.$dialog.message.success(`이벤트 참여가 완료되었습니다.`, {timeout: 2000});
            } else if (response.data.code === 'ETC_ERROR') {
              this.$router.push({name: 'login', query: {redirect: this.$route?.fullPath},});
            }
          }).catch(error => {
            if (error.response.data.code === 'ALREADY_PLAYER_NO') {
              this.$dialog.message.error(`이미 해당 이벤트 참여 하셨습니다.`, {timeout: 2000});
            }
          }).finally(() => {
            this.isLoading = false; // response가 온 후 loading 상태를 false로 설정
            this.isClicking = false;
          });
    },
    // gameDelete() {
    //   this.$axios.delete(`/v2/events/olens-game/delete-temp`)
    //       .then(response => {
    //         if (response.status === 200) {
    //           this.$dialog.message.success(`게임참여가 취소되었습니다.`, {timeout: 2000});
    //           this.playerNumber = undefined;
    //           this.voteResult = null;
    //           this.$router.replace(this.$route.fullPath);
    //         }
    //       }).catch(() => {
    //         this.playerNumber = undefined;
    //         this.$router.replace(this.$route.fullPath);
    //       });
    // },
    productLink(path) {
      this.$router.push({ name: 'product',params: { productId: path } }); // 원하는 라우트 이름 사용
    },
    selectVoteTeam(team) {
      if(!this.playerNumber) {
        this.$dialog.message.error('게임 시작하기를 통해 번호를 받으세요', { timeout: 1000 });
        return;
      }
      if (this.isClicking) {
         this.$dialog.message.error('연속 투표는 불가능합니다. 잠시 후 시도해주세요.', { timeout: 1000 });
        return;
      }
      this.isLoading = true;
      this.isClicking = true;
      this.$axios.post(`/v2/events/olens-game/votes`,{
            selectedTeam: team,
          },
      ).then(response => {
        if (response.data.code === 'SUCCESS') {
          this.$dialog.message.success(`투표 참여 하셨습니다.`, {timeout: 2000});
          this.voteResult = response.data.data.voteResult;
        }
      }).catch(error => {
        if (error.response.data.code === 'ALREADY_PLAYER_NO') {
          this.$dialog.message.error(`이미 해당 이벤트 참여 하셨습니다.`, {timeout: 2000});
        }
      }).finally(() => {
        this.isLoading = false; // response가 온 후 loading 상태를 false로 설정
        this.isClicking = false;
      });
    },
    async voteScroll(anchorTarget) {
      const targetElement = document.getElementById(anchorTarget);

      if (targetElement) {
        // 클릭 이벤트가 발생하면 scroll-padding-top 적용
        document.documentElement.style.scrollPaddingTop = '10px'; // 헤더height만큼 오차 2/1

        // Promise를 반환하는 scrollIntoView 함수 생성
        const scrollIntoView = (element) => {
          return new Promise((resolve) => {
            element.scrollIntoView({behavior: "smooth"});
            setTimeout(resolve, 500);  // scrollIntoView의 실행 시간을 대략적으로 추정
          });
        }

        // scrollIntoView가 완료되면 scroll-padding-top 제거
        await scrollIntoView(targetElement);
        document.documentElement.style.scrollPaddingTop = '';
      } else {
        console.error(`Element with id ${anchorTarget} not found`);
      }
    },
  }
}
</script>

<style lang="scss">
.gameStart {
  background-color: #0b0b0b;
  padding-bottom: 200px;
  position: relative;
  img {
    width: 100%;
  }
  &__btn {
    appearance: none;
    border: none;
    padding: 0 !important;
    height: auto !important;
    font-size: 0;
    background-color: #0b0b0b !important;
  }
  &__delete {
    appearance: none;
    border: none;
    width: 90%;
    padding: 0 !important;
    height: auto !important;
    font-size: 30px;
    padding-block: 30px !important;
    background-color: #fff !important;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 230px;
  }
  &__numberList {
    position: absolute;
    width: 100%;
    padding-inline:110px;
    top: 355px;
    font-size: 70px;
    font-weight: 700;
    color:#000;
    letter-spacing: 65px;
  }
}
.gameProduct {
  display: flex;
  gap: 12px;
  background-color: #1a1c29;
  & img {
    cursor: pointer;
    width: calc(50% - 6px);
  }
}
.event-video {
  vertical-align: middle;
  width: 686px;
  background-color: #000;
}
.gameVote {
  background: #1a1c29;
  padding-bottom: 150px;
  img {
    width: 100%;
  }
  .btn_snsShare {
    background: #f7e600 url("https://file.o-lens.com/event/202412/ico_kakao.png") no-repeat 130px 50% / 25px;
    font-size: 28px;
    display: flex;
    justify-content: center;
    align-content: center;
    width: 90%;
    font-weight: 700;
    margin:50px auto 0;
    border-radius: 48px;
    padding-block: 20px;
  }
  .voteText {
    font-size: 28px;
    text-align: center;
    color:#fff;
    margin-top: 40px;
    span {
      color:#ff3b8f;
      font-weight: 700;
    }
  }
  .btnVoteWrap {
    display: flex;
    justify-content: space-between;
    [class^="btnVoteWrap__team"] {
      width: calc(50% - 6px);
      font-size: 30px;
      padding-block: 20px;
      font-weight: 700 ;
    }
    &__team__a {
      background-color: #8f2bff;
      border-bottom-right-radius: 16px;
    }
    &__team__b {
      background-color: #fffa55;
      border-bottom-left-radius: 16px;
    }
  }
  .voteResultWrap__bar {
    display: flex;
    font-size: 30px;
    font-weight: 700;
    .team__a {
      padding-block:20px;
      background-color: #8f2bff;
      text-align: center;
    }
    .team__b {
      padding-block:20px;
      background-color: #fffa55;
      text-align: center;
    }
  }
}
</style>